module.exports = __webpack_public_path__ + "static/media/IMG_2327.3f0dfc45.jpg";